import { strings } from '../assets/strings';

export const DatasetPropertiesEnum = {
  dataSize: strings.dataset_details.dataset_properties_data_size,
  dataSource: strings.dataset_details.dataset_properties_data_source,
  language: strings.dataset_details.dataset_properties_language,
  deliveryMethod: strings.dataset_details.dataset_properties_delivery_method,
  format: strings.dataset_details.dataset_properties_format,
};
